import { setSelPrivateCloudProject, getSelPrivateCloudProject } from '@/libs/util'

export default {
  state: {
    selPrivateCloudProject: getSelPrivateCloudProject(),
    cacheData: {}
  },
  mutations: {
    setSelPrivateCloudProject (state, project) {
      state.selPrivateCloudProject = project
      setSelPrivateCloudProject(project)
    },
    setCacheData (state, data) {
      state.cacheData = data
    }
  },
  actions: {
    // 保存选择的项目
    saveSelPrivateCloudProject ({ commit }, project) {
      commit('setSelPrivateCloudProject', project)
    },
    // 保存缓存数据
    saveCacheData ({ commit }, data) {
      commit('setCacheData', data)
    }
  }
}
